<template>
  <div class="action-btns d-flex">
    <b-button
      variant="danger"
      block
      class="mr-1"
      v-shortkey.once="['ctrl', 'x']"
      :title="parseInt(state.billing.billing.total_qty) == 0 ? '' : 'ctrl+x'"
      @shortkey="cancelBillShortKey"
      @click="cancelBill"
      :disabled="parseInt(state.billing.billing.total_qty) == 0"
      id="clear-all"
      >Clear All</b-button
    >
    <b-button
      v-shortkey.once="['ctrl', 'b']"
      :title="checkoutCondition == false ? 'ctrl+b' : ''"
      @shortkey="checkoutShortkey()"
      variant="success"
      block
      class="mr-1"
      :disabled="checkoutCondition"
      @click="checkBalance"
      id="checkout-btn"
      >{{ refundMode == false ? "Checkout" : "Continue" }}</b-button
    >

    <!-- Message Box -->
    <message-box
      :open="error"
      @close-message="flushError"
      :message="errorMsg"
    />

    <!-- inventory Checker Modal -->
    <b-modal
      ref="inventory-model"
      size="sm"
      hide-footer
      centered
      no-close-on-backdrop
      no-close-on-esc
      :title="'Insufficient Inventory'"
    >
      <p
        class="pt-2"
        v-text="
          `${$store.getters.checkStock.unavailable} product(s) in your cart do not have sufficient stock. Order status will remain ‘Pending’ till stock becomes available, or the products are discarded/replaced.`
        "
      ></p>
      <p class="pt-2" v-text="'Do you still wish to continue this order?'"></p>
      <div class="d-flex pt-3">
        <b-button
          class="mr-1"
          block
          @click="$refs['inventory-model'].hide()"
          variant="outline-primary"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          block
          class="ml-1"
          @click="checkBalance('force')"
        >
          <span v-if="!$loading">Continue</span>
          <b-spinner small v-if="$loading" />
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import * as msg from "../message";
import MessageBox from "../components/MessageBox";
import * as helper from "../helper";

export default {
  name: "action-btns",
  // props: { refundMode: Boolean },
  components: {
    MessageBox,
  },
  data() {
    return {
      error: false,
      errorMsg: {
        btnText: "",
        text: "",
        type: "",
        info: "",
      },
    };
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    negativeBilling() {
      return this.$store.getters.negativeBilling;
    },
    checkoutCondition() {
      let check = false;
      // if (this.negativeBilling) {
      //   check = false;
      // }
      if (parseInt(this.state.billing.billing.total_qty) == 0) {
        check = true;
      }
      if (parseInt(this.state.billing.billing.total_payable) <= 0) {
        check = true;
      }
      return check;
    },
    refundMode() {
      return this.state.billing.billing.refund_mode;
    },

    isOfflineEnabled() {
      let check = false;
      if (
        this.state.system.settings.vendor_app_menu.hasOwnProperty("offline") &&
        this.state.system.settings.vendor_app_menu.offline.status == 1
      ) {
        check = true;
      }
      return check;
    },
  },
  methods: {
    setRefundType() {
      this.$refs["return-mode-modal"].hide();
    },
    checkBalance(type = "check") {
      if (this.state.billing.billing.billing_mode == "order") {
        if (
          this.$store.getters.checkStock.unavailable != 0 &&
          type != "force"
        ) {
          this.$refs["inventory-model"].show();
          return;
        }
      }
      this.$refs["inventory-model"].hide();
      if (this.state.system.isOffline == true && this.isOfflineEnabled) {
        if (
          this.state.system.settings.settlement.open_sesssion_compulsory
            .status == 1
        ) {
          if (
            this.state.system.settings.settlement.opening_balance_status == 0
          ) {
            this.error = true;
            this.errorMsg.text = msg.OPENING_BALANCE;
            this.errorMsg.btnText = "Continue";
            this.errorMsg.type = "session";
          } else {
            this.checkout();
          }
        }
      } else {
        let settings_date_time = this.state.system.settings.setting_date_time
          .date_time;
        let settings_date = this.$moment(
          settings_date_time,
          "DD-MM-YYYY"
        ).format("YYYY-MM-DD");
        let current_date = this.$moment().format("YYYY-MM-DD");
        if (this.$moment(current_date).isAfter(settings_date, "day")) {
          this.$loading = true;
          this.$store.dispatch("system/getLatestSettings").then(() => {
            if (
              this.state.system.settings.settlement.open_sesssion_compulsory
                .status == 1 &&
              this.state.system.settings.settlement.opening_balance_status == 0
            ) {
              this.$loading = false;
              this.errorMsg.text = msg.OPEN_SESSION;
              this.errorMsg.info = msg.OPEN_SESSION_INFO;
              this.errorMsg.btnText = "Close";
              this.error = true;
            } else {
              this.$loading = false;
              this.checkout();
            }
          });
        } else {
          if (
            this.state.system.settings.settlement.open_sesssion_compulsory
              .status == 1 &&
            this.state.system.settings.settlement.opening_balance_status == 0
          ) {
            this.errorMsg.text = msg.OPEN_SESSION;
            this.errorMsg.info = msg.OPEN_SESSION_INFO;
            this.errorMsg.btnText = "Close";
            this.error = true;
          } else {
            this.checkout();
          }
        }
      }
    },
    cancelBill() {
      //untag salesman
      this.state.billing.billing.cart.data.map((item) => {
        item.salesman_id = 0;
      });
      // console.log(value);
      this.$loading = true;
      let productData = {
        barcode: "",
        url: "remove-product-from-cart",
        product_id: "",
        cart_id: "",
        all: "1",
        cust_gstin: this.state.billing.billing.customer.data.hasOwnProperty(
          "gstin"
        )
          ? this.state.billing.billing.customer.data.gstin
          : "",
      };
      let data = Object.assign(
        productData,
        this.essentialsData,
        this.customerData
      );
      this.$store
        .dispatch("billing/cancelBill", data)
        .then(() => {
          this.$loading = false;
          if (this.isOfflineEnabled && this.state.system.forceOffline == true) {
            this.$store.commit("system/forceOfflineStatus", false);
            this.$store.commit("system/setConnected", false);
            helper.syncApiToken();
          }
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    cancelBillShortKey() {
      if (
        parseInt(this.state.billing.billing.cart.cart_qty_total) != 0 &&
        !this.$loading
      )
        this.cancelBill();
      else if (this.$loading) this.cancelBill();
    },
    async checkout() {
      if (
        !this.checkEmpty(this.state.system.printer) &&
        !qz.websocket.isActive()
      )
        qz.websocket.connect();
      this.$loading = true;
      await helper.checkInvoiceId();
      if (this.state.system.isOffline == false && this.isOfflineEnabled) {
        helper.getInvoiceId("order");
        // helper.getInvoiceId("invoice");
      }

      if (
        this.state.system.settings.vendor_app_menu.customer_logins.DEFAULT
          .status == 1 &&
        this.state.system.settings.vendor_login_details.c_id ==
          this.customerData.c_id
      ) {
        this.error = true;
        this.errorMsg.text = msg.CUSTOMER_MANDATORY;
        this.errorMsg.btnText = "Continue";
        this.errorMsg.info = msg.CUSTOMER_MANDATORY_INFO;
        this.errorMsg.type = "session";
        this.$loading = false;
      } else if (
        this.state.system.settings.vendor_app_menu.customer_logins.DEFAULT
          .status == 1 &&
        this.state.billing.billing.billing_mode == "normal" &&
        this.state.billing.billing.customer.group_settings.items_limit_perday &&
        parseFloat(
          this.state.billing.billing.customer.group_settings
            .maximum_limit_perday
        ) < parseFloat(this.state.billing.billing.cart.cart_qty_total)
      ) {
        let diff =
          parseFloat(this.state.billing.billing.cart.cart_qty_total) -
          parseFloat(
            this.state.billing.billing.customer.group_settings
              .maximum_limit_perday
          );

        this.error = true;
        this.errorMsg.text =
          "<h6>Daily Item limit exceeded</h6> Maximum " +
          this.state.billing.billing.customer.group_settings
            .actual_maximum_limit_perday +
          " items can be purchased in a single day. Please remove at least " +
          diff +
          " item(s) to checkout.";
        this.errorMsg.btnText = "Dismiss";
        this.errorMsg.type = "";
        this.$loading = false;
      } else if (
        this.state.billing.billing.billing_mode == "normal" &&
        this.state.system.settings.vendor_app_menu.customer_logins.DEFAULT
          .status == 1 &&
        this.state.billing.billing.customer.group_settings.value_limit_perday &&
        parseFloat(this.state.billing.billing.cart.total) >
          parseFloat(
            this.state.billing.billing.customer.group_settings
              .maximum_value_perday
          )
      ) {
        let diff =
          parseFloat(this.state.billing.billing.cart.total) -
          parseFloat(
            this.state.billing.billing.customer.group_settings
              .maximum_value_perday
          );

        this.error = true;
        this.errorMsg.text =
          "<h6>Daily Value limit exceeded</h6> Purchase value cannot be more than " +
          this.currencySymbol +
          parseFloat(
            this.state.billing.billing.customer.group_settings
              .actual_maximum_value_perday
          ).toFixed(2) +
          " per day. Please remove item(s) worth at least " +
          this.currencySymbol +
          parseFloat(diff).toFixed(2) +
          " to checkout.";
        this.errorMsg.btnText = "Dismiss";
        this.errorMsg.type = "";
        this.$loading = false;
      } else if (
        this.state.billing.billing.billing_mode == "normal" &&
        this.state.system.settings.vendor_app_menu.customer_logins.DEFAULT
          .status == 1 &&
        this.state.billing.billing.customer.group_settings
          .items_limit_perbill &&
        parseFloat(
          this.state.billing.billing.customer.group_settings
            .maximum_limit_perbill
        ) < parseFloat(this.state.billing.billing.cart.cart_qty_total)
      ) {
        let diff =
          parseFloat(this.state.billing.billing.cart.cart_qty_total) -
          parseFloat(
            this.state.billing.billing.customer.group_settings
              .maximum_limit_perbill
          );

        this.error = true;
        this.errorMsg.text =
          "<h6>Bill Item limit exceeded</h6> Maximum " +
          this.state.billing.billing.customer.group_settings
            .maximum_limit_perbill +
          " items can be purchased in a single bill. Please remove at least " +
          diff +
          " item(s) to checkout.";
        this.errorMsg.btnText = "Dismiss";
        this.errorMsg.type = "";
        this.$loading = false;
      } else if (
        this.state.billing.billing.billing_mode == "normal" &&
        this.state.system.settings.vendor_app_menu.customer_logins.DEFAULT
          .status == 1 &&
        this.state.billing.billing.customer.group_settings
          .value_limit_perbill &&
        parseFloat(this.state.billing.billing.cart.total) >
          parseFloat(
            this.state.billing.billing.customer.group_settings
              .maximum_value_perbill
          )
      ) {
        let diff =
          parseFloat(this.state.billing.billing.cart.total) -
          parseFloat(
            this.state.billing.billing.customer.group_settings
              .maximum_value_perbill
          );

        this.error = true;
        this.errorMsg.text =
          "<h6>Bill Value limit exceeded</h6> Purchase value cannot be more than " +
          this.currencySymbol +
          parseFloat(
            this.state.billing.billing.customer.group_settings
              .maximum_value_perbill
          ).toFixed(2) +
          " per bill. Please remove item(s) worth at least " +
          this.currencySymbol +
          parseFloat(diff).toFixed(2) +
          "  to checkout.";
        this.errorMsg.btnText = "Dismiss";
        this.errorMsg.type = "";
        this.$loading = false;
      } else {
        this.$store.commit("giftVoucher/setGvSale", false);
        let postData = {
          amount: this.state.billing.billing.total_payable,
          sub_total: this.state.billing.billing.subtotal,
          discount: this.state.billing.billing.discount,
          tax_total: this.state.billing.billing.taxes,
          total: this.state.billing.billing.total_payable,
          bill_buster_discount: this.state.billing.billing.cart
            .bill_buster_discount,
          employee_id: "",
          employee_discount: "",
          pay_by_voucher: "",
          payment_gateway_type: "",
          bill_buster_id: "",
          temp_order_id: "",
          manual_discount_factor: "",
          manual_discount_basis: "",
          manual_discount: "",
          transaction_sub_type: "",
          // trans_type:
          // this.state.billing.billing.billing_mode == "return" ? "return" : "",
          url: "process-to-payment",
          cust_gstin: this.state.billing.billing.customer.data.hasOwnProperty(
            "gstin"
          )
            ? this.state.billing.billing.customer.data.gstin
            : "",
        };
        let data = Object.assign(
          postData,
          this.essentialsData,
          this.customerData
        );
        this.$store
          .dispatch("billing/checkOut", data)
          .then((res) => {
            this.$store.commit("billing/setOrderDueDate", "");
            let cust_info = res.data.customer_info;
            cust_info.customer_bal =
              cust_info.customer_bal == null ? "0.00" : cust_info.customer_bal;
            if (res.data.status == "proceed_to_payment") {
              this.$store.commit("billing/getOnAccountData", cust_info);
              this.$router.push("checkout");
            } else if (res.data.status == "add_opening_balance") {
              this.error = true;
              this.errorMsg.text = msg.OPENING_BALANCE;
              this.errorMsg.btnText = "Continue";
              this.errorMsg.type = "session";
            }
            this.$loading = false;
          })
          .catch(() => (this.$loading = false));
      }
    },
    checkoutShortkey() {
      if (
        parseInt(this.state.billing.billing.total_qty) != 0 &&
        this.state.billing.billing.total_payable != "0.00"
      ) {
        if (this.$loading == false) {
          this.checkBalance();
        }
      }
    },
    flushError(val) {
      this.error = val;
      if (this.errorMsg.type == "SessionOpen") {
        this.session.openBox = true;
      }
      this.errorMsg = {
        btnText: "",
        text: "",
        type: "",
      };
    },
  },
};
</script>
